import { plural } from '@epicuro-next/platform/i18n';

export const getMaxShownTextOrNumber = (
  quantity: number,
  maxShownQuantity: number,
  maxUnlimitedQuantityToOrder?: number,
  prioritizeMaxUnlimitedQuantityShown: boolean = false,
) => {
  if (
    prioritizeMaxUnlimitedQuantityShown &&
    maxUnlimitedQuantityToOrder &&
    quantity > maxUnlimitedQuantityToOrder
  ) {
    return maxUnlimitedQuantityToOrder;
  }

  if (quantity > maxShownQuantity) {
    return plural(
      maxShownQuantity,
      {
        0: $localize`:Config Strip|Total max shown items for a delivery period 0@@deliveryPeriodTotalInBasketMaxZero:${maxShownQuantity}+ items`,
        1: $localize`:Config Strip|Total max shown items for a delivery period 1@@deliveryPeriodTotalInBasketMaxOne:${maxShownQuantity}+ item`,
      },
      $localize`:Config Strip|Total max shown items for a delivery period default@@deliveryPeriodTotalInBasketMaxDefault:${maxShownQuantity}+ items`,
    );
  }

  return quantity;
};
